import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';

/* Everything Wundo offers for a 1:1: prepared automatically, and the notetaker joins to write it up. */
export function fullySupported(colleague: OneOnOneColleagueItem): boolean {
  return colleague.supported && colleague.notetaker;
}
